import script from "./ComputeQualityPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./ComputeQualityPage.vue?vue&type=script&lang=ts&setup=true"

import "./ComputeQualityPage.vue?vue&type=style&index=0&id=2e0e5642&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e0e5642"]])

export default __exports__